import { Container } from "aurelia-framework";
import store from "../store";
import { IState, LocationState } from "../state";
import { Api } from "../../services/api";
import { applicationLogger } from "../../logging/logger";
import { Location } from "../../models/location";
import * as Enumerable from "linq-es2015";
import { AddDeviceRequestViewModel } from "../../models/add-device-request-view-model";
import { Zone } from "../../models/zone";
import { Structure } from "../../models/structure";
import { MeasurementViewModel } from "../../models/measurement-view-model";

const api: Api = Container.instance.get(Api);

export async function addOrUpdateCurrentMeasurement(state: IState, measurementViewModel: MeasurementViewModel) {
	const newState = Object.assign({}, state);
	applicationLogger.debug("Adding new device");

	const currentLocation = newState.locationState.currentLocation;
	return newState;
}
